export const DETAILS_FORM_ID = 'replaceMeterDetailsStepForm';
